import { register } from '@shopify/theme-sections'
import Breakpoints from '../core/breakpoints-tailwind'

const initPlyrVideo = (selector) => {
  return new Plyr(selector, {
    controls: ['play', 'mute'],
    autoplay: true,
    muted: true,
    hideControls: false,
    loop: { active: true },
    vimeo: {
      background: true,
      loop: true,
      autoplay: true,
      playsinline: true,
      responsive: true
    }
  })
}


register('hero', {
  onLoad() {
    const desktopScreens = Breakpoints.get('md+')

    const selector_video_desktop = '.hero-video-desktop'
    const selector_video_mobile = '.hero-video-mobile'
    const exist_video_desktop = document.querySelector(selector_video_desktop) ? true : false
    const exist_video_mobile = document.querySelector(selector_video_mobile) ? true : false
    let video_desktop = null
    let video_mobile = null

    const selector_image_desktop = '.hero-image-desktop'
    const selector_image_mobile = '.hero-image-mobile'
    let image_desktop = document.querySelector(selector_image_desktop)
    let image_mobile = document.querySelector(selector_image_mobile)

    const initDesktopVideo = () => {
      video_desktop = initPlyrVideo(selector_video_desktop)
    }
    const playDesktopVideo = () => {
      if (!video_desktop)
        initDesktopVideo()

      if (!video_desktop.playing) {
        video_desktop.play()
      }

      stopMobileVideo()
    }

    const stopDesktopVideo = () => {
      if (video_desktop)
        video_desktop.stop()
    }

    const initMobileVideo = () => {
      video_mobile = initPlyrVideo(selector_video_mobile)
    }
    const playMobileVideo = () => {
      if (!video_mobile)
        initMobileVideo()

      if (!video_mobile.playing) {
        video_mobile.play()
      }

      stopDesktopVideo()
    }
    const stopMobileVideo = () => {
      if (video_mobile)
        video_mobile.stop()
    }

    if (exist_video_desktop || exist_video_mobile) {
      if (desktopScreens.isMatched()) {
        if (exist_video_desktop)
          playDesktopVideo()
        else if (image_desktop)
          stopMobileVideo()
      } else {
        if (exist_video_mobile)
          playMobileVideo()
        else if (image_mobile)
          stopDesktopVideo()
      }

      desktopScreens.on({
        enter: () => {
          if (exist_video_desktop)
            playDesktopVideo()
          else if (image_desktop)
            stopMobileVideo()
        },

        leave: () => {
          if (exist_video_mobile)
            playMobileVideo()
          else if (image_mobile)
            stopDesktopVideo()
        }
      })
    }
  },

  onUnload() {

  }
})
